import { IsDate, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { EmailAttemptStatus } from '../email-attempt-status.enum';
import { EmailTriggers } from '../email-triggered.enum';

export class EmailAttemptDto {
  @IsString()
  @IsNotEmpty()
  triggered!: EmailTriggers;

  @IsDate()
  @IsNotEmpty()
  date!: Date;

  @IsString()
  @IsNotEmpty()
  status!: EmailAttemptStatus;

  @IsOptional()
  @IsString()
  failureReason?: string;

  @IsOptional()
  metadata?: Record<string, unknown>;
}
